<h2 class="thm-page-title ng-star-inserted"> {{'dikkat' | transloco}} </h2>

<thm-alert type="warning" class="text-center">
    <span [innerHTML]="'aday.basvuru.eDevletGirisiGerekli' | transloco | safeHtml"></span>
    <div class="mt-2 text-center">
        <thm-button buttonType="success" iconClass="far fa-key" (clicked)="logout()">
            {{'aday.basvuru.eDevletYonlendirme' | transloco}}
        </thm-button>
      </div>
</thm-alert>
